export default {
  home: {
    banner: {
      "title-first": "客户的成功",
      "title-second": "就是 Authing 的成功",
      subtitle: "Authing 已帮助上千家企业和开发者构建标准化的用户身份体系",
      "data-label-count": "客户数量",
      "data-label-industry": "涉及行业",
      "data-label-time": "服务时间",
    },
    example: {
      "heigh-educate": {
        title: "高等教育出版社 - 传统企业的转型之路",
        subtitle:
          "高等教育出版社是中国教育出版传媒集团有限公司的成员单位，是以出版高等教育、职业教育、成人及社会教育等教育类、专业类、科技类出版物为主的综合性大型出版社，本门户网站提供企业资讯、出版图书、数字化产品及课程、教学资源信息。",
        label1: "教育",
        label2: "B2C",
      },
    },
    cardList: {
      title: "了解我们的客户故事",
      item1: {
        title: "高教社",
        text:
          "Authing 帮助高等教育出版社打造智慧身份平台，为用户带来最便捷、最舒适、最适合的登录体验。",
      },
      item2: {
        title: "元气森林",
        text:
          "Authing 通过实现基于飞书组织架构下的不同权限不同访问级别，节省元气森林 80% 的运维工作量。",
      },
      item3: {
        title: "中国石油",
        text: "Authing 提供全套的 C# SDK，满足中国石油快速接入其研发系统。",
      },
      item4: {
        title: "东南大学",
        text:
          "Authing 使用跨平台的 SDK，用五行代码帮助东南大学实现跨平台的用户系统（包含小程序）。",
      },
      item5: {
        title: "大众汽车",
        text:
          "Authing 联邦认证通过标准协议帮助大众汽车建立起上下游合作伙伴各应用提供商之间的信任。",
      },
      item6: {
        title: "宾利汽车",
        text:
          "Authing 帮助宾利汽车轻松处理用户登录的任何数据，间接很大程度提高了研发工作效率。",
      },
      item7: {
        title: "日本丰田",
        text:
          "Authing 帮助丰田快速集成他们的新老应用，大大减缩减了新应用的研发周期和上市时间。",
      },
      item8: {
        title: "JCDcaux",
        text:
          "Authing 为德高集团搭建了统一认证中心，帮助德高集团完成了身份管理和设备管理服务。",
      },
      item9: {
        title: "BOSCH",
        text:
          "Authing 用可伸缩性、高扩展的 SaaS  平台部署模式，大大缩短了博世集团的研发周期。",
      },
      item10: {
        title: "PingCAP",
        text:
          "Authing 对员工入离职管理和信息同步的产品能力，帮助 PingCAP 大大降低了运维时间和成本。",
      },
      item11: {
        title: "四川大学华西医院",
        text:
          "Authing 为四川大学华西医院构建了身份供应体系，减少因人员身份管理不规范带来的信息安全风险。",
      },
      item12: {
        title: "Bentley",
        text:
          "Authing 为奔特利（Bentley）保障了其内部开发者和外部用户登录和身份验证时的安全性。",
      },
      // item1: {
      //   title: "TOYOTA",
      //   text:
      //     "日本丰田是世界十大汽车工业公司之一，是日本最大的汽车公司，创立于 1933 年，现在已发展成为以汽车生产为主；业务涉及机械、电子、金融等行业的庞大工业集团。丰田汽车公司有很强的技术开发能力，十分注重研究顾客对汽车的需求。因而在它的发展各个不同历史阶段创出不同的名牌产品，而且以快速的产品换型击败美欧竞争对手。",
      //   allText:
      //     "日本丰田是世界十大汽车工业公司之一，是日本最大的汽车公司，创立于 1933 年，现在已发展成为以汽车生产为主；业务涉及机械、电子、金融等行业的庞大工业集团。丰田汽车公司有很强的技术开发能力，十分注重研究顾客对汽车的需求。因而在它的发展各个不同历史阶段创出不同的名牌产品，而且以快速的产品换型击败美欧竞争对手。Authing 针对用户提供统一身份安全管理平台并部署实施，帮助丰田管理大规模用户增长。",
      // },
      // item2: {
      //   title: "招商银行",
      //   text:
      //     "招商银行 1987 年成立于中国改革开放的最前沿——深圳蛇口，是中国境内第一家完全由企业法人持股的股份制商业银行，也是国家从体制外推动银行业改革的第一家试点银行。招商银行在境内银行业率先推出了离岸业务、买方信贷、国内信用证业务、公司理财与网上承兑汇票业务等。",
      //   allText:
      //     "招商银行 1987 年成立于中国改革开放的最前沿——深圳蛇口，是中国境内第一家完全由企业法人持股的股份制商业银行，也是国家从体制外推动银行业改革的第一家试点银行。招商银行在境内银行业率先推出了离岸业务、买方信贷、国内信用证业务、公司理财与网上承兑汇票业务等。Authing 帮助招商银行提升了内部统一身份管理的能力，极大降低了运维成本，并加速推进了业务成功。",
      // },
      // item3: {
      //   title: "金蝶",
      //   text:
      //     "金蝶国际软件集团有限公司始创于 1993 年，是香港联交所主板上市公司，总部位于中国深圳。IDC 数据显示，金蝶不仅连续 16 年稳居中国成长型企业应用软件市场占有率第一、更连续 2 年在中国企业级应用 SaaS 云服务市场占有率排名第一，连续 4 年在中国企业级 ERM SaaS （即云 ERP）、财务 SaaS 市场占有率第一。",
      //   allText:
      //     "金蝶国际软件集团有限公司始创于 1993 年，是香港联交所主板上市公司，总部位于中国深圳。IDC 数据显示，金蝶不仅连续 16 年稳居中国成长型企业应用软件市场占有率第一、更连续 2 年在中国企业级应用 SaaS 云服务市场占有率排名第一，连续 4 年在中国企业级 ERM SaaS （即云 ERP）、财务 SaaS 市场占有率第一。Authing 提供统一身份认证平台，帮助金蝶高效管理用户身份。",
      // },
      // item4: {
      //   title: "东南大学",
      //   text:
      //     "东南大学是国家教育部直属的全国重点大学，是国家「985 工程」和「211 工程」重点建设大学之一。",
      //   allText:
      //     "东南大学是国家教育部直属的全国重点大学，是国家「985 工程」和「211 工程」重点建设大学之一。通过 Authing，仅用五行代码便实现了跨平台用户系统的单点登录。",
      // },
      // item5: {
      //   title: "Bentley",
      //   text:
      //     "Bentley（奔特利）工程软件有限公司成立于 1984 年，员工 4000 多人，在全球 172 个国家设有分支机构，年收入超过 8 亿美元，被评为全球第二大地理信息软件解决方案提供商。",
      //   allText: "",
      // },
      // item6: {
      //   title: "EY",
      //   text:
      //     "EY（安永）是世界四大会计师事务所之一，是大中华区规模最大的专业服务机构之一，在区内提供专业服务已有 40 年。",
      //   allText:
      //     "EY（安永）是世界四大会计师事务所之一，是大中华区规模最大的专业服务机构之一，在区内提供专业服务已有 40 年。这段期间，安永取得多项具里程碑意义的发展：安永的前身雅特杨会计师事务所于 1968 年在香港成立首个办事处；1981 年安永成为首批获准在中国大陆开展业务的国际专业服务机构之一。",
      // },
      // item7: {
      //   title: "THERAGUN",
      //   text:
      //     "Theragun 也是运动康复品牌中的佼佼者，在撞击式按摩领域已深耕近 10 年，全球有 250 多个专业运动队使用 Theragun。",
      //   allText:
      //     "Theragun 也是运动康复品牌中的佼佼者，在撞击式按摩领域已深耕近 10 年，全球有 250 多个专业运动队使用 Theragun。Authing 为其提供云端身份安全管理服务，解决企业内外部用户的身份管理问题。",
      // },
      // item8: {
      //   title: "中国石油",
      //   text:
      //     "中国石油天然气集团有限公司是国有重要骨干企业和中国主要的油气生产商和供应商之一，是集油气勘探开发、炼油化工、销售贸易、管道储运、工程技术、工程建设、装备制造、金融服务于一体的综合性国际能源公司，在国内油气勘探开发中居主导地位，在全球 35 个国家和地区开展油气业务。",
      //   allText:
      //     "中国石油天然气集团有限公司是国有重要骨干企业和中国主要的油气生产商和供应商之一，是集油气勘探开发、炼油化工、销售贸易、管道储运、工程技术、工程建设、装备制造、金融服务于一体的综合性国际能源公司，在国内油气勘探开发中居主导地位，在全球 35 个国家和地区开展油气业务。Authing 提供了完善的单点登录平台，帮助中国石油快速实现高效用户管理。",
      // },
      // item9: {
      //   title: "高教社",
      //   text:
      //     "高等教育出版社（以下简称高教社）成立于 1954 年 5 月，是新中国最早设立的专业教育出版机构之一。高教社与包括众多知名出版商在内的全球 200 多家机构开展广泛的合作，24 个语种版本的国际型产品在世界 60 多个国家发行，版权输出数量在全国单体出版社中连年名列前茅。",
      //   allText:
      //     "高等教育出版社（以下简称高教社）成立于 1954 年 5 月，是新中国最早设立的专业教育出版机构之一。高教社与包括众多知名出版商在内的全球 200 多家机构开展广泛的合作，24 个语种版本的国际型产品在世界 60 多个国家发行，版权输出数量在全国单体出版社中连年名列前茅。Authing 帮助高等教育出版社快速地集成千万用户，完成舒适流畅的登录体验。",
      // },

      // item10: {
      //   title: "国家电网",
      //   text:
      //     "国家电网有限公司成立于 2002 年，是关系国民经济命脉和国家能源安全的特大型国有重点骨干企业。公司以投资、建设、运营电网为核心业务，承担着保障安全、经济、清洁、可持续电力供应的基本使命。2019 年《财富》世界 500 强排行榜发布，国家电网有限公司位列第 5 位。",
      //   allText:
      //     "国家电网有限公司成立于 2002 年，是关系国民经济命脉和国家能源安全的特大型国有重点骨干企业。公司以投资、建设、运营电网为核心业务，承担着保障安全、经济、清洁、可持续电力供应的基本使命。2019 年《财富》世界 500 强排行榜发布，国家电网有限公司位列第 5 位。Authing 通过提供完善的身份管理服务，助力国家电网全面实现身份治理，提升信息安全，强化风险控制。",
      // },

      // item11: {
      //   title: "PingCap",
      //   text:
      //     "PingCAP 成立于 2015 年，是一家企业级开源分布式数据库厂商，提供包括开源分布式数据库产品、解决方案与咨询、技术支持与培训认证服务。",
      //   allText:
      //     "PingCAP 成立于 2015 年，是一家企业级开源分布式数据库厂商，提供包括开源分布式数据库产品、解决方案与咨询、技术支持与培训认证服务，致力于为全球行业用户提供稳定高效、安全可靠、开放兼容的新型数据基础设施，解放企业生产力，加速企业数字化转型升级。",
      // },
      // item12: {
      //   title: "德高集团",
      //   text:
      //     "德高集团（JCDecaux Group）创立于 1964 年，是全球排名第一的国际性户外媒体公司，并在巴黎 Euronext 上市。业务遍布全球 50 多个国家的 3688 个城市，运营着 1013510 多个广告位，拥有 10304 名员工。德高集团在 2019 年实现了创纪录的业绩表现， 达到 38.902 亿欧元的收益。如今，德高集团已成为全球最具影响力的媒体网络之一，也是在本地化程度上最灵活的媒体网络之一。",
      //   allText:
      //     "德高集团（JCDecaux Group）创立于 1964 年，是全球排名第一的国际性户外媒体公司，并在巴黎 Euronext 上市。业务遍布全球 50 多个国家的 3688 个城市，运营着 1013510 多个广告位，拥有 10304 名员工。德高集团在 2019 年实现了创纪录的业绩表现， 达到 38.902 亿欧元的收益。如今，德高集团已成为全球最具影响力的媒体网络之一，也是在本地化程度上最灵活的媒体网络之一。Authing 帮助企业用户快速接入企业内部应用系统，完成账号同步、单点登录和访问授权。",
      // },
      // item13: {
      //   title: "云测",
      //   text:
      //     "Testin 云测创立于 2011 年，是一家以人工智能技术驱动的企业服务平台，为全球超过百万的企业及开发者提供云测试服务、AI 数据标注服务、安全服务及 RPA 服务。Testin 云测通过工具、技术、人才、服务四位一体的共享，加速企业智能化、数字化、科技化的进程，为企业在各行业中的智能化升级与商业化落地保驾护航，释放创新力量，赋能企业改变世界。",
      //   allText:
      //     "Testin 云测创立于 2011 年，是一家以人工智能技术驱动的企业服务平台，为全球超过百万的企业及开发者提供云测试服务、AI 数据标注服务、安全服务及 RPA 服务。Testin 云测通过工具、技术、人才、服务四位一体的共享，加速企业智能化、数字化、科技化的进程，为企业在各行业中的智能化升级与商业化落地保驾护航，释放创新力量，赋能企业改变世界。Authing 提供的云端身份安全管理服务，解决企业多账户、多密码、多处访问等痛点。",
      // },
      // item14: {
      //   title: "元气森林",
      //   text:
      //     "元气森林成立于 2016 年，是自主研发、自主设计的创新型饮品品牌。仅短短 5 年时间，在无糖软饮市场上拔得头筹，荣登《第一财经》金字招牌碳酸饮料榜榜首。",
      //   allText:
      //     "元气森林成立于 2016 年，是自主研发、自主设计的创新型饮品品牌。仅短短 5 年时间，在无糖软饮市场上拔得头筹，荣登《第一财经》金字招牌碳酸饮料榜榜首，业务不仅覆盖全国，还出口美国、新西兰、新加坡等 40 多个国家和地区。",
      // },
      // item15: {
      //   title: "Bentley",
      //   text:
      //     "宾利（Bentley Motors Limited），英国豪华汽车品牌，总部位于英国克鲁。1919 年，W.O. 宾利先生创办了宾利汽车公司。“To build a fast car, a good car, the best in its class.”（要造一台快的车，好的车，同级别中最出类拔萃的车。）",
      //   allText:
      //     "宾利（Bentley Motors Limited），英国豪华汽车品牌，总部位于英国克鲁。1919 年，W.O. 宾利先生创办了宾利汽车公司。“To build a fast car, a good car, the best in its class.”（要造一台快的车，好的车，同级别中最出类拔萃的车。）曾是创始人华特·欧文·宾利先生最初追求极致卓越的造车理念。",
      // },
      // item16: {
      //   title: "Volkswagen",
      //   text:
      //     "大众汽车（德语：Volkswagen）是一家总部位于德国沃尔夫斯堡的汽车制造公司，也是世界四大汽车生产商之一的大众集团的核心企业。",
      //   allText:
      //     "大众汽车（德语：Volkswagen）是一家总部位于德国沃尔夫斯堡的汽车制造公司，也是世界四大汽车生产商之一的大众集团的核心企业。2019 年位居《财富》世界 500 强第 9 位。 Volks 在德语中意思为“国民”，Wagen 在德语中意思为“汽车”，全名的意思即“国民汽车”，故又常简称为“VW”。台湾译为福斯汽车，港澳、大陆译为大众汽车或福士汽车。",
      // },
      // item17: {
      //   title: "Treelab",
      //   text:
      //     "Treelab 创立于 2019 年，创始团队起初发现上至营收亿级企业，下至个人门店都在使用手工或 Excel 方式记录管理业务。",
      //   allText:
      //     "Treelab 创立于 2019 年，创始团队起初发现上至营收亿级企业，下至个人门店都在使用手工或 Excel 方式记录管理业务。却无法找到能适应业务场景的工具，更是没有预算采购定制化工具。Treelab 的诞生正是激发每个人的创造力，让不擅长技术的人也能根据自身业务场景，灵活搭建自己的办公工具。",
      // },
    },
  },
  "heigh-educate": {
    banner: {
      title: "高等教育出版社",
      subtitle:
        "Authing 帮助高等教育出版社打造智慧身份平台，为用户带来最便捷、最舒适、最适合的登录体验。",
      brandDescript: `“对比过众多厂商后更能感受到 Authing 的优势，这是一款经过思考做出来的产品。”`,
    },
    intro: {
      title: "客户介绍",
      imgUrl: "//files.authing.co/authing-website/customer-intro-hep-zn.png",
      descript1:
        "高等教育出版社（以下简称高教社）成立于 1954 年 5 月，是新中国最早设立的专业教育出版机构之一。高教社现有在职员工 1700 余人，年出书万余种，发行近 1.3 亿册。出版社规模、员工数量居国内出版社前列。",
      descript2:
        " 在教育部的领导下，高教社承担了全国高校思想政治工作网、中国大学生在线两个网站的建设和运营工作，目前思政网已覆盖各省级党委教育工作部门、75 所教育部直属高校和其他部委高校、2500 所地方高校。中国大学生在线网站会员总数已达到 1120 万人，再创历史新高。",
      descript3:
        "高教社与包括众多知名出版商在内的全球 200 多家机构开展广泛的合作，24 个语种版本的国际型产品在世界 60 多个国家发行，版权输出数量在全国单体出版社中连年名列前茅。连续多次被评为国家文化出口重点企业。",
    },
    challenge: {
      title: "需求挑战",
      item1: {
        title: "问题一",
        description: "高教社的 3500 万用户分布在几十个软件平台，IT 管理复杂。",
      },
      item2: {
        title: "问题二",
        description:
          "高教社需要出色的用户登录体验，提高与国内教育市场、国际出版商的合作。",
      },
      item3: {
        title: "问题三",
        description: "承担思政网的建设工作，意味着防欺诈、安全保障格外重要。",
      },
      item4: {
        title: "问题四",
        description:
          "运营思政网、大学生在线网等多个网站，高教社对跨品牌单一登录的需求强烈。",
      },
    },
    ideas: {
      title: "想法变现实",
      item1: {
        title: "舒适的用户体验",
        subtitle:
          "在与高教社的合作中，Authing 团队提供全程一对一的咨询与技术服务，加速网站上线，支持客户成功。",
      },
      item2: {
        title: "保障企业身份信息安全",
        subtitle:
          "通过提供多因素认证、登录环境监测等安全技术，Authing 为高教社打造了专业的安全防护。",
      },
      item3: {
        title: "完善的身份服务",
        subtitle:
          "凭借 Authing 完善的身份认证和访问管理服务，两位工程师用了一个下午就完成了部署测试，轻松集成了高教社的千万用户。实现了在一处、用一个账号跨品牌登录的体验。",
      },
      item4: {
        title: "提高系统的可扩展性",
        subtitle:
          "Authing 平台弹性灵活，文档、软件包丰富，在高教社的迅速发展中，为其提供了拓展、集成能力，减少日常的维护工作，降低未来的开发成本，打造高效愉悦的开发方式，让 IT 管理化繁为简，加速业务成长。",
      },
    },
  },
  cnpn: {
    banner: {
      title: "中国石油",
      subtitle:
        "Authing 提供完善的单点登录平台，帮助中国石油快速实现高效用户管理。",
    },
    intro: {
      title: "客户介绍",
      imgUrl: "//files.authing.co/authing-website/customer-intro-cnpn-zn.png",
      descript1:
        "中国石油天然气集团有限公司是国有重要骨干企业和中国主要的油气生产商和供应商之一，是集油气勘探开发、炼油化工、销售贸易、管道储运、工程技术、工程建设、装备制造、金融服务于一体的综合性国际能源公司，在国内油气勘探开发中居主导地位，在全球 35 个国家和地区开展油气业务。",
      descript2:
        "2020 年，公司在世界 50 家大石油公司综合排名中位居第三，在《财富》杂志全球 500 家大公司排名中位居第四。",
    },
    challenge: {
      title: "需求挑战",
      item1: {
        title: "问题一",
        description:
          "中国石油旗下某研究所总计千余人，使用的软件服务总计 10 余个，IT 管理复杂。",
      },
      item2: {
        title: "问题二",
        description:
          "公司希望其成员使用该公司账号即可登录所有软件，然而现有业务系统老旧，安全、认证创新困难。",
      },
      item3: {
        title: "问题三",
        description:
          "核心功能研发本身已耗时许久，然而用户验证功能却一直未处理完善，公司希望加速研发周期。",
      },
    },
    ideas: {
      title: "想法变现实",
      item1: {
        title: "舒适的用户体验",
        subtitle:
          "Authing 提供了完善的单点登录平台，为旗下 Web 和 App 均快速实现了用户验证和访问管理功能。",
      },
      item2: {
        title: "保障企业身份信息安全",
        subtitle: "Authing 提供全套的 C# SDK，满足中国石油快速接入其研发系统。",
      },
      item3: {
        title: "完善的身份服务",
        subtitle:
          "在中国石油重点关注的移动端单点登录上，Authing 具备「自动检测同一设备上关联应用的登录状态」、「唤起关联 App 以交换用户信息」，方便中国石油依据场景做出选择。",
      },
    },
  },
  dongnan: {
    banner: {
      title: "东南大学",
      subtitle: "五行代码帮助东南大学实现跨平台用户系统的单点登录。",
    },
    intro: {
      title: "客户介绍",
      imgUrl:
        "//files.authing.co/authing-website/customer-intro-dongnan-zn.png",
      descript1:
        "东南大学坐落于六朝古都南京，是享誉海内外的著名高等学府。学校是国家教育部直属并与江苏省共建的全国重点大学，是国家「985 工程」和「211 工程」重点建设大学之一。",
      descript2:
        "东南大学现有 33 个院系、77 个本科专业，有 33 个博士学位一级学科授权点，49 个硕士学位一级学科授权点。有全日制在校生 30664 人，其中本科生 16128 人、研究生 14536 人；在校留学生 1989 人，其中学历留学生 1547 人。学校建有四牌楼、九龙湖、丁家桥等校区，占地面积 5888 亩，其中九龙湖校区 3752.35 亩，总建筑面积约 78.97 万平方米。",
    },
    challenge: {
      title: "需求挑战",
      item1: {
        title:
          "东南大学在开发 BIM 系统时遇到单点登录问题，需要联合自研系统（BIM 系统）和三方系统（Odoo、Strapi、C9.io）做统一认证和授权，而 BIM 系统本身的研发极其复杂，若同时进行单点登录的研发将拖慢项目上线速度，最终影响工地工作人员使用。并且，该 BIM 系统除了 Web 端外，还存在小程序端，多端跨平台的用户系统研发又会引入其他复杂性问题。另外由于 BIM 组织机构复杂，需要细粒度的权限分级，研发基于角色的授权模型又将拖慢系统上线速度。",
        description: "",
      },
    },
    ideas: {
      title: "想法变现实",
      item1: {
        title: "",
        subtitle:
          "Authing 重视教育市场，为东南大学提供全程一对一的咨询与技术服务，加速其系统上线，支持业务成功。",
      },
      item2: {
        title: "",
        subtitle:
          "Authing 使用基于 OAuth 2.0 的单点登录方案，连接 BIM 系统和 Odoo、Strapi 和 C9.io；使用基于 RBAC 的授权方案，统一对组织机构和工作人员进行授权分级；使用跨平台的 SDK，用五行代码实现跨平台的用户系统（包含小程序）。",
      },
    },
  },
  "xian-gong": {
    banner: {
      title: "仙工智能",
      subtitle: "Authing 提供统一身份认证平台，帮助企业高效管理用户身份。",
    },
    intro: {
      title: "客户介绍",
      imgUrl:
        "//files.authing.co/authing-website/customer-story-detail-intro-xiangong-zn.png",
      descript1:
        "上海仙工智能科技有限公司（简称 SEER）是一家专注于智能生产和智慧物流的高新技术企业，业务涵盖了通用 AMR 控制器、企业数字化中台、基于视觉系统的车厂协同方案以及自动叉车在内的各类 AMR，为各行业的客户提供一站式全感知物流解决方案，以标准产品支撑非标应用，致力于推动工业的信息化、数字化、智能化转型升级。",
      descript2:
        "从发现需求到解决需求，从解决需求到创造需求，SEER 坚持在客户需求与自身的多层次需求中寻找突破，聚焦工业智能化，进行开放式创新，为合作伙伴创造价值。",
    },
    challenge: {
      title: "需求挑战",
      item1: {
        title: "问题一",
        description:
          "企业基础设施平台的用户管理能力薄弱，同时技术手段较落后，应用系统间数据相互隔离，无法统一进行管理，存在数据孤岛效应。",
      },
      item2: {
        title: "问题二",
        description:
          "随着业务的推进和员工数量的激增，在复杂的业务场景和组织架构下，内部员工的权限管理和分配成为了难题。",
      },
      item3: {
        title: "问题三",
        description:
          "企业内部系统之间，没有统一的身份认证授权流程，用户在使用应用系统的时候，需要重复进行认证授权流程，阻碍了生产效率同时用户体验较差。",
      },
    },
    ideas: {
      title: "想法变现实",
      item1: {
        title: "",
        subtitle:
          "基于云原生的 Authing 身份基础设施平台，帮助企业完成了数字化转型和云端的身份融合，打破了数据孤岛，为企业提供了标准统一的身份体系。",
      },
      item2: {
        title: "",
        subtitle:
          "Authing 基于 RBAC/ABAC 的权限系统模型，帮助企业实现了高效、灵活且细粒度的的权限管理和分配。",
      },
      item3: {
        title: "",
        subtitle:
          "Authing 支持多种标准的认证授权协议：OIDC、OAuth2、SAML、CAS 等，通过应用间单点登录，实现了统一的认证授权流程，极大提高了企业的生产效率。",
      },
    },
  },
  deephow: {
    banner: {
      title: "Deephow",
      addtionTitle: "（深昊科技）",
      subtitle: `Authing 为 Deephow（深昊科技）提供自定义程度高的社会化登录，为其用户带来最便捷的第三方登录体验。`,
      brandDescript: ``,
    },
    intro: {
      title: "客户介绍",
      imgUrl: "//files.authing.co/authing-website/customer-intro-deephow.png",
      descript1:
        "Deephow（深昊科技）开发了一个由 AI 驱动的学习平台，致力于为制造业、服务业等提供 AI 教学培训和智能视频培训服务，让用户在产品安装使用时能更省时省事。",
      descript2:
        "Deephow 的这一解决方案能帮助企业客户减少前期产品投入使用时的教育培训成本，这比传统的线下培训形式投入的资源要节省10倍，从而广受客户欢迎。",
    },
    challenge: {
      title: "需求挑战",
      item1: {
        title:
          "Deephow（深昊科技）需要寻求一家提供简单易用的社会化登录平台，简化其用户在第三方平台诸如微信、win form 等的登录体验，同时为其用户在第三方平台创建账号提供一种更加简单便捷的方式。",
        description: "",
      },
    },
    ideas: {
      title: "想法变现实",
      item1: {
        title: "",
        subtitle:
          "在与 Deephow（深昊科技）的合作中，Authing 团队提供全程一对一的咨询与技术服务，支持客户成功。",
      },
      item2: {
        title: "",
        subtitle:
          "通过使用 C# SDK 的接入方式，Authing 为 Deephow（深昊科技）提供可自定义程度高的社会化登录，为其用户带来更加便捷的第三方账号创建&登录体验。",
      },
    },
  },
  theragun: {
    banner: {
      title: "THERAGUN",
      addtionTitle: "（赛锐康）",
      subtitle:
        "Authing 帮助 THERAGUN 打造易用性高的统一身份认证平台，完美实现应用无缝对接，提升用户体验。",
      brandDescript: ``,
    },
    intro: {
      title: "客户介绍",
      imgUrl: "//files.authing.co/authing-website/customer-intro-theragun.png",
      descript1:
        "THERAGUN 是美国最大的筋膜枪品牌，成立于 2008 年。其产品采用独创的冲击式疗法深层按摩肌肉，可以起到缓解肌肉紧张、加速恢复、提高身体机能的作用，同时还为用户提供舒缓肌肉、缓解疼痛用的外敷产品。",
      descript2:
        "全球有 250 多支专业运动队（NFL、NBA、NHL、MLB、MLS、NASCAR）信赖 THERAGUN ，全球 50 余个国家/地区的教练、理疗师、脊医和普通大众亦在使用。",
    },
    challenge: {
      title: "需求挑战",
      item1: {
        title:
          "THERAGUN 已经在他们的电子商务网站上使用了 Shopify 的认证，但 Shopify 在身份认证解决方案上专业度不够。考虑到产品的易用性，THERAGUN 决定采用更专业的登录解决方案，来解决现有应用系统复杂的登录模式，实现统一身份认证。",
        description: "",
      },
    },
    ideas: {
      title: "想法变现实",
      item1: {
        title: "",
        subtitle:
          "Authing 为 THERAGUN 提供了新的统一认证系统，并在短短 7 周的时间内完成他们所有客户的迁移，缓解了大量客户登录和认证带来的压力。",
      },
      item2: {
        title: "",
        subtitle:
          "凭借 Authing 完善的身份认证和访问管理服务，共计为 THERAGUN 节省了约 60 万美元的技术人力成本，并省去了接近 50 %的开发工时。",
      },
    },
  },
  bentley: {
    banner: {
      title: "Bentley",
      addtionTitle: "（奔特利）",
      subtitle:
        "Authing 为奔特利（Bentley）内部开发者和外部用户均提供的无缝、便捷而又安全的认证体验，保障其登录和身份验证时的安全性。",
    },
    intro: {
      title: "客户介绍",
      imgUrl:
        "//files.authing.co/authing-website/customer-intro-bentley-zn.png",
      descript1:
        "Bentley（奔特利）工程软件有限公司成立于 1984 年，员工 4000 多人，在全球 172 个国家设有分支机构，年收入超过 8 亿美元，被评为全球第二大地理信息软件解决方案提供商。",
      descript2:
        "Bentley（奔特利）通过为企业和专业人员提供基于设计、建造和运营公路、桥梁、轨道交通、给排水、公共工程和公用事业、园区以及工业设施的解决方案。",
    },
    challenge: {
      title: "需求挑战",
      item1: {
        title: "问题一",
        description:
          "作为一家全球性的企业，Bentley（奔特利）已经在全球范围内已经完成了身份体系的搭建，但现阶段使用的身份管理产品无法满足奔特利（Bentley）中国团队业务的快速发展的需求，中国团队希望寻求一家国内的优秀身份认证提供商，来快速完成现有应用系统与身份的集成。",
      },
      item2: {
        title: "问题二",
        description:
          "单一的认证访问方式，业务安全无法保障。现在 Bentley（奔特利）中国的业务采用用户名+密码的单一认证方式，安全性得不到保证，部分系统密码设置也不符合密码的要求，存在安全隐患。",
      },
      item3: {
        title: "问题三",
        description:
          "缺乏清晰实时操作和安全访问审计，无法满足企业安全合规上的需求。随着业务的快速发展，针对用户访问、权限使用和数据管理，缺乏实时有效的事前预警、事中审计和事后追溯的路径。",
      },
    },
    ideas: {
      title: "想法变现实",
      item1: {
        title: "舒适的用户体验",
        subtitle:
          "Authing 提供了完善的单点登录平台，为旗下 Web 和员工系统均快速实现了高效的认证和访问管理功能。",
      },
      item2: {
        title: "保障企业身份信息安全",
        subtitle:
          "Authing 提供了多种认证方式供 Bentley（奔特利）选择：组合、密码策略、登录频繁检测、自定义认证流程等，并且都可以通过管理控制台轻松配置完成。",
      },
      item3: {
        title: "完善的身份服务",
        subtitle:
          "Authing 基于用户行为审计、管理员审计和应用访问情况为 Bentley（奔特利）实现了可视化安全审计的策略，支持不同人员（组）设定不同的密码策略。多因素认证让用户访问无缝、敏捷和安全。",
      },
    },
  },
  futu: {
    banner: {
      title: "富途牛牛",
      addtionTitle: "",
      subtitle:
        "富途牛牛通过 Authing 实现企业微信安全登录和扫码认证，保障企业信息安全。",
    },
    intro: {
      title: "客户介绍",
      imgUrl: "//files.authing.co/authing-website/customer-intro-futu-zn.png",
      descript1:
        "深圳市富途网络科技有限公司成立于 2007 年，是腾讯战略投资，纳斯达克上市公司富途控股（NASDAQ: FUTU）旗下子公司，主要从事互联网科技类产品的研发，提供面向个人投资者的市场数据、资讯、社交等服务。",
      descript2:
        "旗下富途证券等美港股券商提供面向个人投资者的美股、港股、A 股通的股票交易和清算、融资融券、财富管理等服务，并以用户为中心构建完善的金融科技生态系统，连接用户、投资者、企业、证券分析师、媒体和意见领袖。",
    },
    challenge: {
      title: "需求挑战",
      item1: {
        title: "",
        description:
          "富途公司在内部同时使用腾讯企业微信和腾讯会议进行日常经营管理，希望实现通过企业微信直接登录到腾讯会议。但如果通过企业微信自有应用直接认证的方式，会将组织机构、邮箱、手机号等私密信息直接暴露出来，造成企业安全风险。此外，需要保证企业微信的密钥信息安全可控，不可以存放在公网或第三方环境。",
      },
    },
    ideas: {
      title: "想法变现实",
      item1: {
        title: "",
        subtitle:
          "员工通过 Authing 中的企业微信登录腾讯会议并按企业微信中设定的不同组织架构和权限进入会议。",
      },
      item2: {
        title: "保障企业身份信息安全",
        subtitle:
          "通过 Authing 的 IDaaS 产品中「企业微信（第三方应用）扫码登录」功能进行桥接，使用 OpenID Connection 协议实现企业微信扫码认证。",
      },
    },
  },
  jcdecaux: {
    banner: {
      title: "JCDecaux",
      addtionTitle: "（德高集团）",
      subtitle:
        "Authing 为德高集团搭建了统一认证中心，提供的身份供应功能，帮助德高集团完成了身份管理和设备管理服务，形成完整统一且权威的身份数据源，提高广告投放效率 75%。",
    },
    intro: {
      title: "客户介绍",
      imgUrl:
        "//files.authing.co/authing-website/customer-story-detail-intro-jcdcaux-zn.png",
      descript1:
        "德高集团 (JCDecaux Group) 创立于 1964 年，是全球排名第一的国际性户外媒体公司，并在巴黎 Euronext 上市。业务遍布全球 50 多个国家的 3,688 个城市，2005 年 ，德高进入中国市场，业务遍及 12 个城市（含香港澳门），163,355 广告位，21% 城镇人口覆盖，每日触达受众 1.7 亿人次。在中国有 1300 多名员工。",
      descript2:
        "随着中国户外广告市场的高速发展，德高在中国的表现已成为集团全球市场中的一个亮点，作为中国领先的户外广告公司，德高中国在地铁媒体、公交、机场及接到设施媒体等四大领域内提供最佳服务。",
    },
    challenge: {
      title: "需求挑战",
      item1: {
        title: "问题一",
        description:
          "德高中国在 12 个城市部署的广告屏设备安全管理难度大，目前自研技术实现周期长，成本高。",
      },
      item2: {
        title: "问题二",
        description:
          "自研 B2B、B2E 的广告投放平台等多个应用的身份管理和授权，以及完成多应用与广告设备的授权登录，给研发团队带来了极大的工作量。",
      },
      item3: {
        title: "问题三",
        description:
          "1000+ 广告设备无法实现统一管理和运营策略，给运维人员带来极大的工作量。",
      },
    },
    ideas: {
      title: "想法变现实",
      item1: {
        title: "",
        subtitle:
          "针对德高中国自研广告投放平台的统一身份认证和管理问题，采用 Authing 身份云产品，帮助打通员工对设备的集中访问管控，构建城市区域中心认证节点，提升设备认证可用性、稳定性和性能，同时对应用状态实时监控，确保设备统一管理和安全。",
      },
      item2: {
        title: "",
        subtitle:
          "直接调用 Authing 基于身份管理的 API 接口，快速实现企业内身份供给和管理，实现员工账号及组织开通、启动、禁用，删除及停用功能，针对下游提供用户及组织信息同步。",
      },
      item3: {
        title: "",
        subtitle: "接入企业内部应用系统，完成账号同步，单点登录和访问授权。",
      },
    },
  },
  "bentley-motors": {
    banner: {
      title: "Bentley",
      addtionTitle: "（宾利汽车）",
      subtitle:
        "Authing 平台的规则和映射功能的结合使我们能够轻松地处理用户登录的任何数据。最重要的是，我们不必要求合作伙伴以不同的格式发送数据，SSO 可以满足他们的需求。Authing 大大减少了我们的运维工作量。",
    },
    intro: {
      title: "客户介绍",
      imgUrl:
        "//files.authing.co/authing-website/customer-story-detail-intro-bentley-motors-zh.png",
      descript1: `宾利（Bentley Motors Limited），宾利是世界优质汽车的制造商之一，总部位于英国克鲁。 
        “To build a fast car, a good car, the best in its class.” 曾是创始人华特·欧文·宾利先生最初追求极致卓越的造车理念。
        近一个世纪之后，宾利先生的理念仍继续指引其信念、行动和宏大目标。宾利汽车居顶级英国豪华汽车之列，手工打造全世界最佳性能的豪华旅行轿车，宾利在1997年被大众集团收购。`,
      descript2: "",
    },
    challenge: {
      title: "需求挑战",
      item1: {
        title: "问题一",
        description:
          "宾利汽车研发团队需要打造企业内部统一的身份源，为企业内部员工实现统一身份认证和授权功能，提高研发工作效率，减少运维工作量。",
      },
      item2: {
        title: "问题二",
        description:
          "企业自研应用，统一身份登录认证和管理授权功能不能复用，新旧应用身份集成存在困难。",
      },
      item3: {
        title: "问题三",
        description:
          "面向集团内部数百用户及上下游合作伙伴，企业 B2B、B2E 容器云平台，想要实现合规的安全的身份登录认证体系。",
      },
    },
    ideas: {
      title: "想法变现实",
      item1: {
        title: "",
        subtitle:
          "Authing 统一的身份解决方案支持多合作伙伴的身份验证，快速、敏捷，与现有应用实现无缝对接。",
      },
      item2: {
        title: "",
        subtitle:
          "Authing 身份云基于规范的工作流来处理宾利内部及所有上下游供应商的身份验证要求，让用户账密登录更安全合规。",
      },
      item3: {
        title: "",
        subtitle:
          "统一的身份源，帮助宾利汽车集成内部自研应用系统，完成用户账密同步、单点登录、访问授权和多因素认证。提供审计日志的存储和记录，利于数据安全和问题溯源。",
      },
    },
  },
  yuanqi: {
    banner: {
      title: "元气森林",
      addtionTitle: "",
      subtitle:
        "Authing 打通飞书产品，为我们提供身份源能力，快速的部署及开发者友好，满足了我们现有和未来的需求，为我们节省了大量的研发人力、费用和周期，让我们将这些宝贵的资源更多应用在公司和客户上。",
    },
    intro: {
      title: "客户介绍",
      imgUrl:
        "//files.authing.co/authing-website/customer-story-detail-intro-yuanqi.png",
      descript1:
        "2016 年成立的元气森林食品科技集团是自主研发、自主设计的创新型饮品公司。品牌秉持“用户第一”的使命，立足健康需求，破除口味壁垒，传递健康生活理念。目前，元气森林系列产品已覆盖全国，并出口美国、新西兰、新加坡等40多个国家和地区。",
      descript2:
        "元气森林一直在学习传统行业的玩法，又在颠覆传统行业的玩法。2020 年前，元气森林线上与线下销量比为 7：3，而在 2021 年，线下销量将有可能超越线上。在上年度《第一财经》发布的金字招牌榜单上，元气森林荣登碳酸饮料榜榜首。与此同时，元气森林 2020 年的年销售额也达到约 30 亿。",
    },
    challenge: {
      title: "需求挑战",
      item1: {
        title: "问题一",
        description:
          "元气森林目前 5000 多员工的应用登录管理和授权问题，且随着员工的不断增长，传统 IAM 难以解决不断扩容的问题，如何使用通用登录来管理内部用户的角色和权限，确保安全内置到每个员工对应的级别系统，是目前运维人员管理的难点。",
      },
      item2: {
        title: "问题二",
        description:
          "内部几十个应用系统的集成，与身份体系的打通，集成飞书，通过飞书将组织架构体系打通，实现员工单点登录，目前自研力度较大，时间周期长。",
      },
      item3: {
        title: "问题三",
        description:
          "希望寻找一个身份云提供商，解决不断增长的应用和员工规模，应对企业未来不断扩张带来可持续的增长和高效率。",
      },
    },
    ideas: {
      title: "想法变现实",
      item1: {
        title: "",
        subtitle:
          "Authing 突破性的单点登录技术，无需任何开发，快速助力元气森林实现员工一个账号密码登录所有应用，并统一管控身份权限。",
      },
      item2: {
        title: "",
        subtitle:
          "Authing 通过与飞书产品层面的打通，为元气森林提供身份供应，实现基于飞书组织架构下的不同权限不同访问级别，节省运维人员 80% 的工作量。",
      },
      item3: {
        title: "",
        subtitle:
          "Authing 为元气森林提供一站式团队应用平台，实现成员和集中管控访问权限，打造高效的办公方式，简化人事、IT管理，加速企业成长。",
      },
    },
  },
  volkswagen: {
    banner: {
      title: "大众汽车",
      addtionTitle: "",
      subtitle:
        "Authing 为我们提高效率，减少开发运维费用，并节省了宝贵的时间和资源。",
    },
    intro: {
      title: "客户介绍",
      imgUrl:
        "//files.authing.co/authing-website/customer-story-detail-intro-volkswagen.png",
      descript1:
        "大众汽车（德语：Volkswagen）是一家总部位于德国沃尔夫斯堡的汽车制造公司，也是世界四大汽车生产商之一的大众集团的核心企业。2019 年位居《财富》世界 500 强第9 位。",
      descript2:
        "大众汽车传承优良的造车 DNA ，更着力研发创新性的智能科技。大众不断突破现实的壁垒，用技术将想象落地，为人们出行创造更多可能性。每一项有意思的科技，都让出行更有意思。",
    },
    challenge: {
      title: "需求挑战",
      item1: {
        title: "问题一",
        description:
          "大众旗下众多品牌及上下游合作伙伴供应商都需登录集团诸多应用，且各应用之间访问时的身份互认，是现在研发团队的难点。",
      },
      item2: {
        title: "问题二",
        description:
          "老旧应用与新研发的应用之间，没有实现身份集成，账号互相隔离，形成信息孤岛。访问不同系统时，需要多次认证，用户体验不佳。",
      },
      item3: {
        title: "问题三",
        description:
          "业务及管理越来越需要快速交付不要的信息以及应用系统，救火式的应对难以应付，需要统一规范的身份体系来支撑快速交付。",
      },
    },
    ideas: {
      title: "想法变现实",
      item1: {
        title: "",
        subtitle:
          "Authing 统一的身份解决方案帮助大众汽车完成了应用系统用户身份的认证，授权管理和认证保证用户登录安全可控。",
      },
      item2: {
        title: "",
        subtitle: `Authing 联邦认证通过标准协议将不同的身份提供商联合起来对用户进行认证，帮助大众汽车上下游合作伙伴各应用提供商之间建立信任关系，实现账号同步、单点登录和访问授权。`,
      },
      item3: {
        title: "",
        subtitle:
          "Authing 可伸缩性、高扩展的 SaaS  平台部署模式，帮助大众汽车实现多用户和应用的连接，以及面向未来应用扩展的需求。",
      },
    },
  },
  toyota: {
    banner: {
      title: "丰田",
      addtionTitle: "",
      subtitle:
        "无需重新构建或重复构建身份登录体系，通过 Authing 的身份源，即可快速集成我们的新老应用，大大减缩减了我们新应用的研发周期和上市时间。",
    },
    intro: {
      title: "客户介绍",
      imgUrl:
        "//files.authing.co/authing-website/customer-detail-intro-toyota.png",
      descript1:
        "丰田汽车公司成立于 1937 年，距今已有八十多年的历史。丰田在中国的事业可追溯至1964 年对华出口首批 CROWN 皇冠轿车。长久以来，丰田一直致力于为中国广大消费者不断提供高品质的产品和服务，切实履行企业社会责任，从而为社会和汽车产业的可持续发展做贡献。如今，丰田已在中国设立 28 家主要的独资和合资公司，2019 年，在华销量达到 162 万辆，为丰田在华历史最好成绩。",
      descript2: "",
    },
    challenge: {
      title: "需求挑战",
      item1: {
        title: "问题一",
        description:
          "研发团队需要开发 B2C 租车业务应用，统一身份认证功能开发周期长、拖累核心应用开发进度，需要统一规范的身份体系来支撑快速交付。",
      },
      item2: {
        title: "问题二",
        description:
          "原有应用身份认证系统不能复用到新应用中，新旧应用身份集成存在困难。 新应用万级以上的用户身份认证和管理，给运维带来极大工作量。",
      },
      item3: {
        title: "问题三",
        description:
          "用户数据安全问题，现有的用户管理流程不够清晰，覆盖不全面，存在一些管理薄弱点及落实不到位问题，无法满足行业监管审计的要求。",
      },
    },
    ideas: {
      title: "想法变现实",
      item1: {
        title: "",
        subtitle:
          "Authing 提供的 SaaS 标准化身份云产品，为日本丰田提供身份供应源，帮助丰田研发团队快速部署身份安全管理平台，缩短新应用研发的周期。",
      },
      item2: {
        title: "",
        subtitle: `接入企业现有应用系统，完成身份账号同步、单点登录和访问授权问题。Authing 针对开发者友好的可扩展性、高伸缩性，满足丰田后续开发新应用中的身份登录及 C 端用户万级用户的流量问题。`,
      },
      item3: {
        title: "",
        subtitle:
          "Authing 的自适应多因素认证功能，提升用户完全登录，提升信息安全，强化风险控制。安全合规，提升身份治理水平。",
      },
    },
  },
  huaxi: {
    banner: {
      title: "华西医院",
      addtionTitle: "",
      subtitle:
        "Authing 为我们构建了身份供应体系，减少新应用集成的身份源问题，减少因人员身份管理不规范带来的信息安全、隐私风险及运营风险。通过身份安全管理平台建设，保障信息符合国家相关要求和规范，实现技术合规及政策合规。我们非常期待 Authing 为更多组织带去价值。",
    },
    intro: {
      title: "客户介绍",
      imgUrl:
        "//files.authing.co/authing-website/customer-detail-intro-hospital.png",
      descript1:
        "四川大学华西医院（West China Hospital，Sichuan University）是中国西部疑难危急重症诊疗的国家级中心，也是世界规模第一的综合性单点医院，拥有中国规模最大、最早整体通过美国病理家学会（CAP）检查认可的医学检验中心。 在2015年公布的中国公立医院社会贡献度排行榜上总分位列全国第一，连续多年被独立第三方调查评选为“全国最受欢迎三甲医院” 前十强、“医疗机构最佳雇主”前十强。 华西医院现阶段自研医疗软件和内外部应用系统较多，作为特殊的医疗行业，在身份登录安全上和统一管理上要求更高。",
      descript2: "",
    },
    challenge: {
      title: "需求挑战",
      item1: {
        title: "问题一",
        description:
          "华西医院目前没有对用户进行各系统的访问权限进行统一管理，对用户管理缺乏技术的有效控制，容易对应用系统造成信息安全隐患。",
      },
      item2: {
        title: "问题二",
        description:
          "华西医院自研应用与内部现有应用身份的集成，身份供应体系研发成本高，难以复用，造成  IT 资源的浪费，零散的用户管理体系给审计带来了非常大的难度，运维成本高。",
      },
      item3: {
        title: "问题三",
        description: "缺乏清晰实时操作和访问审计，无法满足企业合规要求。",
      },
    },
    ideas: {
      title: "想法变现实",
      item1: {
        title: "",
        subtitle:
          "针对华西医院对接自研系统的需求， Authing 的应用集成网关产品帮助华西快速实现应用的集成和身份源的管理。 ",
      },
      item2: {
        title: "",
        subtitle: `接入华西内部应用系统，完成账号同步、单点登录和访问授权。提供用户身份源相关的审计日志村吃和记录，方便管理者追溯。`,
      },
      item3: {
        title: "",
        subtitle:
          "Authing 提供统一身份管理平台的认证和授权，帮助华西医院实现单点登录，让用户登录更为安全便捷，大大降低了运维人员对用户管理的时间成本和投入。",
      },
    },
  },
  bosch: {
    banner: {
      title: "BOSCH",
      addtionTitle: "",
      subtitle:
        "Authing 对开发者友好，实施快速，基础设施要求门槛低，他们简单的演示和专业知识，使 Authing 极具吸引力，很大的帮助我们节省了部署时间成本及研发周期。",
    },
    intro: {
      title: "客户介绍",
      imgUrl:
        "//files.authing.co/authing-website/customer-detail-intro-bosch.png",
      descript1:
        "博世集团是德国的工业企业之一，是全球第一大汽车技术供应商，从事汽车与智能交通技术、工业技术、消费品和能源及建筑技术的产业。员工人数超过 27万，遍布 50 多个国家。博世以其创新尖端的产品及系统解决方案闻名于世。 博世在中国设立了 11 个独资公司，9 个合资公司和多个贸易公司等，博世正大力支持中国汽车市场的强劲增长。自进入中国市场以来，博世中国不断将先进技术和解决方案引入中国，并参与了一系列中国的重大工程项目。如今，博世的技术又在推陈出新，把技术载入生活，它正在改变人的生活。",
      descript2: "",
    },
    challenge: {
      title: "需求挑战",
      item1: {
        title: "问题一",
        description:
          "可持续的发展对于博世集团这样拥有数百个不同应用、不同产品、不同部门的扩张型公司来说至关重要。在不断扩充的客户、不断推向市场的各类设备进行管理是集团目前面临的问题。",
      },
      item2: {
        title: "问题二",
        description:
          "对于博世用户和设备的连接，怎么进行身份验证，保障访问的安全，访问的权限问题都给研发团队带来极大的困扰。",
      },
      item3: {
        title: "问题三",
        description:
          "多设备和用户的管理，运维人员效率低下且易出错，大量的重复的用户数据需要做冗余存放和同步管理，如何快速调整因设备业务等原因造成的用户变更问题。",
      },
    },
    ideas: {
      title: "想法变现实",
      item1: {
        title: "",
        subtitle:
          "Authing 统一的身份解决方案帮助博世集团完成了所有设备和用户身份的认证，授权管理和认证保证用户登录安全可控。",
      },
      item2: {
        title: "",
        subtitle: `Authing 平台提供设备及用户账号的开通、启用、禁用、删除等功能，对下游提供用户与设备信息的同步，并帮助博世集团实现多用户和多设备连接，以及面向未来设备与应用扩展的需求。`,
      },
      item3: {
        title: "",
        subtitle: "接入企业内部应用系统，完成账号同步、单点登录和访问授权。",
      },
    },
  },
  pingcap: {
    banner: {
      title: "PingCAP",
      addtionTitle: "",
      subtitle:
        "高科技创新的产品，灵活敏捷，响应速度快。没想到我们 40 多个应用的单点登录、协同办公和基于身份供应的上下游需求，用 Authing 产品很快就帮我们实现了需求。",
    },
    intro: {
      title: "客户介绍",
      imgUrl:
        "//files.authing.co/authing-website/customer-detail-intro-pingcap.png",
      descript1:
        "PingCAP 是一家企业级开源分布式数据库厂商，提供包括开源分布式数据库产品、解决方案与咨询、技术支持与培训认证服务。 由 PingCAP 创立的分布式关系型数据库 TiDB，为企业关键业务打造，具备「分布式强一致性事务、在线弹性水平扩展、故障自恢复的高可用、跨数据中心多活」等企业级核心特性，帮助企业最大化发挥数据价值，充分释放企业增长空间。目前，PingCAP 已经向包括中国、美国、欧洲、日本、东南亚等国家和地区，超过 1500 家企业提供服务，涉及金融、运营商、制造、零售、互联网、政府等多个行业。",
      descript2: "",
    },
    challenge: {
      title: "需求挑战",
      item1: {
        title: "问题一",
        description:
          "PingCAP 在长达 3 年的时间里一直存在多个员工身份源，在公司组织机构、跨平台的管理上存在难点，包括飞书，北森，Google 等接近 40 个应用之间的单点登录、协同办公和组织的管理需求。",
      },
      item2: {
        title: "问题二",
        description:
          "PingCAP 在国内、海外多个国家都有办公室，怎样做好各国员工身份管理，降低身份管理和运营成本是现阶段亟待解决的问题。  ",
      },
      item3: {
        title: "问题三",
        description:
          "PingCAP 希望可以通过北森 HR 系统作为企业统一身份源，进行海内外员工入职、单点登录、协同办公（项目组管理）、离职等自动化管理，能够搭建一个身份中台，管理和同步员工信息、组织机构，并可扩展到下游应用中，减少身份重复产研建设。",
      },
    },
    ideas: {
      title: "想法变现实",
      item1: {
        title: "",
        subtitle:
          "基于 OIDC、SAML 协议，Authing 帮助 PingCAP 对接现有全部应用，Authing 的身份供应帮助 PingCAP 实现 单点登录 SSO 的功能，实现使用一个账号登录企业所有应用。",
      },
      item2: {
        title: "",
        subtitle: `基于 SCIM、LDAP 协议实现组织机构供给能和 Authing 身份供给能力，实现 PingCAP 员工身份上下游同步供给的能力，可扩展高可用。`,
      },
      item3: {
        title: "",
        subtitle:
          "Authing 对员工入离职管理和信息同步的产品能力，帮助 PingCAP 大大降低了运维时间和成本。",
      },
    },
  },
};
